export default __webpack_public_path__ + "static/media/split_2.ba401618.svg";